/**
 * Startsidescopy för bokning och betalning.
 * Kassan skapar en väntande förfrågan. Efter bekräftelse: betalningslänk med kort
 * eller Klarna. Faktura erbjuds företag.
 */

export const HOMEPAGE_REQUEST_STEP_TITLE = 'Skicka förfrågan';

export const HOMEPAGE_REQUEST_STEP_DESCRIPTION =
  'Fyll i dina uppgifter och skicka förfrågan. Vi bekräftar bokningen först. Därefter betalar du via betalningslänk med kort eller Klarna. Faktura erbjuds företag.';

export const HOMEPAGE_PAYMENT_FEATURE_DESCRIPTION =
  'Efter bekräftelse betalar du via betalningslänk med kort eller Klarna. Faktura erbjuds företag.';

const STALE_STEP3_TITLES = new Set(['Bekräfta & betala']);

const STALE_STEP3_DESCRIPTIONS = new Set([
  'Fyll i dina uppgifter och betala tryggt online med kort eller Swish.',
  'Fyll i dina uppgifter och betala tryggt online med kort via Stripe.',
  'Fyll i dina uppgifter och skicka förfrågan. Vi bekräftar bokningen först. Därefter betalar du via betalningslänk eller faktura.',
]);

const STALE_PAYMENT_FEATURES = new Set([
  'Betala enkelt och säkert direkt online med alla vanliga betalsätt.',
  'Betalningen sker efter att vi har bekräftat bokningen, via betalningslänk eller faktura.',
]);

function correctedOrKept(
  value: string | null | undefined,
  stale: Set<string>,
  corrected: string,
): string {
  const trimmed = (value ?? '').trim();
  if (!trimmed || stale.has(trimmed)) return corrected;
  return trimmed;
}

export function correctHomepageStep3Title(value: string | null | undefined): string {
  return correctedOrKept(value, STALE_STEP3_TITLES, HOMEPAGE_REQUEST_STEP_TITLE);
}

export function correctHomepageStep3Description(value: string | null | undefined): string {
  return correctedOrKept(value, STALE_STEP3_DESCRIPTIONS, HOMEPAGE_REQUEST_STEP_DESCRIPTION);
}

export function correctHomepagePaymentFeature(value: string | null | undefined): string {
  return correctedOrKept(value, STALE_PAYMENT_FEATURES, HOMEPAGE_PAYMENT_FEATURE_DESCRIPTION);
}
